module.exports = __webpack_public_path__ + "/login_ui/img/nr-f97b92dceab0090f07016fb2967a881f.svg";